
import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import { createWarehouseInChargeTemplate, getWarehouseInChargeTemplate } from "@/api/warehouse-in-charge-template";

@Component({
  name: "WarehouseInChargeTemplate"
})

export default class extends Vue {
  private payload: WarehousingChargeCalculationTemplate = new WarehousingChargeCalculationTemplate();
  private rules = {
    flatbedCartonHandlingUnitPrice: [{ required: true, message: "平板车纸箱装卸单价不能为空", trigger: "blur" }],
    vanCartonHandlingUnitPrice: [{ required: true, message: "厢式车纸箱装卸单价不能为空", trigger: "blur" }],
    highBarTruckCartonHandlingUnitPrice: [{ required: true, message: "高栏车纸箱装卸单价不能为空", trigger: "blur" }],
    flatbedPalletHandlingUnitPrice: [{ required: true, message: "平板车托盘装卸单价不能为空", trigger: "blur" }],
    vanPalletHandlingUnitPrice: [{ required: true, message: "厢式车托盘装卸单价不能为空", trigger: "blur" }],
    highBarTruckPalletHandlingUnitPrice: [{ required: true, message: "高栏车托盘装卸单价不能为空", trigger: "blur" }],
    expressFee: [{ required: true, message: "快递单价不能为空", trigger: "blur" }],
    customsDocCharges: [{ required: true, message: "打单费不能为空", trigger: "blur" }],
    faceSheetProcessingFee: [{ required: true, message: "面单处理费不能为空", trigger: "blur" }],
  };

  created() {
    this.getTemplate();
  }

  private onDialogConfirmed() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        await createWarehouseInChargeTemplate(this.payload);
        this.$notify({
          title: "成功",
          message: "更新成功",
          type: "success",
          duration: 2000
        });
      }
    });
  }

  private async getTemplate() {
    const data: any = await getWarehouseInChargeTemplate();
    this.payload = data;
  }

  //
  // private async handleUpload(file) {
  //   await uploadImages2Oss(this.bizType, this.objectId, [file.file]);
  //   const { content }: any = await getAllImages(this.bizType, this.objectId, { pageSize: 1, pageNumber: 1 });
  // }


}

class WarehousingChargeCalculationTemplate {
  flatbedCartonHandlingUnitPrice: number;
  vanCartonHandlingUnitPrice: number;
  highBarTruckCartonHandlingUnitPrice: number;
  flatbedPalletHandlingUnitPrice: number;
  vanPalletHandlingUnitPrice: number;
  highBarTruckPalletHandlingUnitPrice: number;
  expressFee: string;
  freeVolume: number;
  nightOvertimePay: number;
  customsDocCharges: number;
  faceSheetProcessingFee: number;
}
